export const EVENT_STATUS = {
  draft: {
    label: "Rascunho",
    color: "warning",
  },
  confirmed: {
    label: "Confirmado",
    color: "success",
  },
  completed: {
    label: "Finalizado",
    color: "info",
  },
  cancelled: {
    label: "Cancelado",
    color: "error",
  },
};
